<script setup>
import { nextTick, onMounted, ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

const props = defineProps({
    id: {
        type: String,
        required: false,
    },
    saveScrollPosition: {
        type: Boolean,
        default: true,
    }
});

const el = ref(null);

const saveScrollPosition = async () => {
    const currentState = window.history.state || {};
    window.history.replaceState({
        ...currentState,
        [`scroll-state-${props.id}`]: { top: el.value.scrollTop }
    }, '');
}

const restoreScrollPosition = () => {
    const scroll = window.history.state[`scroll-state-${props.id}`];
    if (!scroll) {
        return;
    }

    el.value.scrollTo({
        top: scroll.top ?? 0,
        left: scroll.left ?? 0,
    });
}

defineExpose({
    restoreScrollPosition,
});

onBeforeRouteLeave(() => {
    if (props.id && props.saveScrollPosition) {
        saveScrollPosition();
    }
});

onMounted(() => {
    if (props.id && props.saveScrollPosition) {
        nextTick(() => {
            restoreScrollPosition();
        });
    }
});
</script>

<template>
    <div ref="el" class="grow w-full overflow-y-auto">
        <slot />
    </div>
</template>
